import { Button } from '@octopus-do/octopus-storybook'
import { Clone } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'
import { useField } from './useField'

export const Field: React.FC = () => {
  const { value, showResetBtn, onChange, onCopyPrompt, onReset } = useField()

  return (
    <div className={css.field}>
      <textarea
        className={css.field_textarea}
        value={value}
        onChange={onChange}
      />

      <div className={css.field_buttons_wrap}>
        {showResetBtn && (
          <Button
            className={css.reset_btn}
            priority="outline"
            size="medium"
            label="Reset"
            onClick={onReset}
          />
        )}
        <Button
          size="medium"
          label="Copy prompt"
          left={Clone}
          onClick={onCopyPrompt}
        />
      </div>
    </div>
  )
}
